export const breakpoints = {
  tiny: '(max-width: 429px)',
  mobile: '(max-width: 767px)',
  tablet: '(max-width: 1199px)',
};
